function SalarySubmitted() {
    return <p className="message text-center">תודה! השכר שלך נשלח לאישור</p>;
  }

  export default SalarySubmitted;